import React from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import PortsAutoComplete from './PortsAutoComplete';
import { PortItem } from './PortItem';
import { RaisedButton } from 'material-ui';
import PortsAreasToggler from '../PortsAreasToggler';

class Ports extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            selectedArea,
            relatedPorts,
            onChangeArea,
            onChangePortFromAutoComplete,
            toggleMainPort,
            portFromAutoComplete,
            removePort,
            addPort,
            showPort,
            showChilds,

            toggleShowPorts,
            toggleShowAreas,
        } = this.props;    

        return (
            <div>
                <div className='row'>
                    <div className='col-xs-9'>
                        <PortsAutoComplete
                            showPort={showPort}
                            onChangeArea={onChangeArea}
                            selectedArea={selectedArea}
                            onChangePortFromAutoComplete={onChangePortFromAutoComplete}
                            portFromAutoComplete={portFromAutoComplete}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <PortsAreasToggler 
                            toggleShowPorts={toggleShowPorts}
                            toggleShowAreas={toggleShowAreas}
                            showChilds={showChilds}
                        />
                    </div>
                </div>

                <div className='paper-block margin-9'>
                    <span className='name-block absolute small-name'>List of ports</span>
                    <div style={{ overflowY: 'scroll', height: '75vh', width: '100%' }}>
                        {
                            selectedArea.childs.size ? Array.from(selectedArea.childs, (portId, index) => (<PortItem
                                key={index}
                                showPort={showPort}
                                child={relatedPorts.get(portId)}
                                isMainPort={selectedArea.mainPorts.has(portId)}
                                removePort={removePort}
                                toggleMainPort={toggleMainPort}
                            />)) : null
                        }
                    </div>
                </div>

            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const relatedPorts = new Map();
    for (const portId of props.selectedArea.childs) {
        relatedPorts.set(portId, _.find(state.ports.items, { _id: portId }));
    }

    return {
        relatedPorts,
    };
}

export default connect(mapStateToProps)(Ports);



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Ports/Component.jsx